import React from "react";
import LinkifiedText, { buildLinkifiedNodes } from "../common/LinkifiedText";

export default function SubmissionSectionTree({ sections = [] }) {
  return sections.map((section) => (
    <Section key={section.sectionId} section={section} level={0} />
  ));
}

function Section({ section, level = 0 }) {
  const {
    sectionCode,
    sectionTitle,
    sectionDescription,
    questions = [],
    children = [],
  } = section;

  const sectionIndent = { marginLeft: `${level * 24}px` };
  const questionIndent = { marginLeft: "16px" };

  return (
    <div className="ids-mb-6" style={sectionIndent}>
      <h3 className="ids-heading-m">
        {sectionCode} {sectionTitle}
      </h3>

      <LinkifiedText className="ids-text-body ids-mb-4" style={{ whiteSpace: "pre-line" }}>
        {sectionDescription}
      </LinkifiedText>

      <div style={questionIndent}>
        {questions.map((q, idx) => (
          <div key={q.questionId} className="ids-mb-4">
            <LinkifiedText className="ids-text-body ids-mb-1">
              {q.questionDescription}
            </LinkifiedText>

            <strong style={{ overflowWrap: "anywhere" }}>
              {idx + 1}. {buildLinkifiedNodes(q.questionText)}
            </strong>

            {q.answerText && (
              <p>
                <strong>Svar:</strong> {q.answerText}
              </p>
            )}

            {q.selectedOption && (
              <div className="ids-mt-2">
                <p>
                  <strong>Svar:</strong> {q.selectedOption.optionText}
                </p>

                {q.selectedOption.followUpQuestion && (
                  <div className="ids-ml-4 ids-mt-1">
                    <em>Följdfråga: {q.selectedOption.followUpQuestion.questionText}</em>
                    <p>Svar: {q.selectedOption.followUpQuestion.answerText || "—"}</p>
                  </div>
                )}
              </div>
            )}

            {q.selectedOptions && q.selectedOptions.length > 0 && (
              <div className="ids-mt-2">
                <p>
                  <strong>Svar:</strong>
                </p>
                <ul>
                  {q.selectedOptions.map((opt) => (
                    <li key={opt.optionId}>
                      {opt.optionText}

                      {opt.followUpQuestion && (
                        <div className="ids-ml-4 ids-mt-1">
                          <em>Följdfråga: {opt.followUpQuestion.questionText}</em>
                          <p>Svar: {opt.followUpQuestion.answerText || "—"}</p>
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </div>

      {children.map((child) => (
        <Section key={child.sectionId} section={child} level={level + 1} />
      ))}
    </div>
  );
}
